export default __webpack_public_path__ + "static/media/kodiaq.7b41c59f.png";